import { useIntl } from "gatsby-plugin-intl"

export const useTranslation = () => {
  const intl = useIntl()
  return (key) => intl.formatMessage({ id: key })
}
